import { render, staticRenderFns } from "./mytree.vue?vue&type=template&id=33471690&scoped=true&"
import script from "./mytree.vue?vue&type=script&lang=js&"
export * from "./mytree.vue?vue&type=script&lang=js&"
import style0 from "./mytree.vue?vue&type=style&index=0&id=33471690&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33471690",
  null
  
)

export default component.exports